<template>
<div >
    <vx-card class="no-scroll-content" ref="content" title="List of Filed Claim" >

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewClaim()" icon-pack="feather" icon="icon-file">Apply Claim</vs-button>
        <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search  :data="employeeClaim">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <!-- <vs-th sort-key="claimsCategoryId">Category</vs-th> -->
                <vs-th sort-key="claimsSubCategoryId">Name</vs-th>               
                <vs-th>Reason</vs-th>
                <vs-th>Reviewer</vs-th>
                <vs-th>Approver</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Reviewer Comment</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].name">
                        {{data[indextr].name}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerId">
                        <vx-tooltip v-bind:text="data[indextr].reviewer.fullName">
                            <div v-if="data[indextr].reviewer.photoUrl !== ''"><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :src="data[indextr].reviewer.photoUrl" /></div>
                            <div v-else><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :text="data[indextr].reviewer.fullName" :color="data[indextr].reviewer.fullName.length < 12 ? 'success' : data[indextr].reviewer.fullName.length <= 15 ? 'primary' : data[indextr].reviewer.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                            <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].reviewer.photoUrl" /> -->
                        </vx-tooltip>
                    </vs-td>
                    
                    <vs-td :data="data[indextr].approverId">
                        <vx-tooltip v-bind:text="data[indextr].approver.fullName">
                            <div v-if="data[indextr].approver.photoUrl !== ''"><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :src="data[indextr].approver.photoUrl" /></div>
                            <div v-else><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :text="data[indextr].approver.fullName" :color="data[indextr].approver.fullName.length < 12 ? 'success' : data[indextr].approver.fullName.length <= 15 ? 'primary' : data[indextr].approver.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                            
                            <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].approver.photoUrl" /> -->
                        </vx-tooltip>
                    </vs-td>
                    <!-- <vs-td style="width:50px" :data="data[indextr].reviewerId">
                        <vx-tooltip v-bind:text="data[indextr].reviewer.firstName + ' ' + data[indextr].reviewer.lastName">
                            <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].reviewer.photoUrl" />
                        </vx-tooltip>
                    </vs-td>
                    
                    <vs-td style="width:50px" :data="data[indextr].approverId">
                        <vx-tooltip v-bind:text="data[indextr].approver.firstName + ' ' + data[indextr].approver.lastName">
                            <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].approver.photoUrl" />
                        </vx-tooltip>
                    </vs-td> -->
                    <!-- <vs-td style="width:50px" :data="data[indextr].photoUrl" >
                        <a v-if="data[indextr].photoUrl != null" :href="data[indextr].photoUrl" target="_blank"   ><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></a>
                    </vs-td> -->
                     <vs-td  :data="data[indextr].photoId" >
                        <vs-icon v-show="data[indextr].photoId != '' && data[indextr].photoId != null" @click="downloadFile(data[indextr].photoId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                    </vs-td>
                    <vs-td :data="data[indextr].remarks">
                        {{data[indextr].remarks}}
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerComment">
                        {{data[indextr].reviewerComment}}
                    </vs-td>
                    <vs-td :data="data[indextr].isUnread">
                        <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                            data[indextr].isCancelled == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                            data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false
                                                              && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isApproverApproved == true ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                            data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                            data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' : ''"/>
                                {{data[indextr].isCancelled == true ? 'Cancelled' :
                                 data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Draft': 
                                 data[indextr].isSubmitted == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied == false  
                                                                   && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'For Review' :
                                data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'Reviewed - For Approval' :
                                 data[indextr].isApproverApproved == true ? 'Approved' :
                                 data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'For Revision' :
                                 data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'Retracted' :
                                 data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'Denied' : ''}}
                        </span>                                                             
                    </vs-td>
                    
                    <vs-td>
                        <div class="vx-row">
                            <div class="flex">
                                <vx-tooltip text="Details">
                                     <vs-button class="mr-3 mb-2" @click="openDetailsClaim(data[indextr].employeeFiledClaimsId)"  color="success" type="border" icon-pack="feather" icon="icon-list" ></vs-button>                             
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Edit' :
                                    data[indextr].isSubmitted == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverDenied == false
                                                                      && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'Un-Submit' : 
                                    data[indextr].isReviewerApproved == true || data[indextr].isApproverApproved == true ? 'Retract' : 
                                    data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? ' Edit' : ''" >
                                    <!-- data[indextr].approversOTs[0].isRetracted == true ? 'Edit' : ''"> -->
                                    <vs-button class="mr-3 mb-2" @click="openEditClaim(data[indextr].employeeFiledClaimsId)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="success" type="border" icon-pack="feather" icon="icon-edit-2" ></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="promptUnSubmitDialog(data[indextr].employeeFiledClaimsId)" v-else-if="data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false" color="warning" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="promptRetrackDialog(data[indextr].employeeFiledClaimsId)" v-else-if="data[indextr].isReviewerApproved == true" color="danger" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="openEditClaim(data[indextr].employeeFiledClaimsId)"  v-else-if="data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true" color="success" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                                    <!-- <vs-button class="mr-3 mb-2" v-else-if="data[indextr].approversOTs[0].isRetracted == true" color="success" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button> -->
                                    <!-- <vs-button v-else color="warning" type="border" icon-pack="feather" icon="icon-send" > </vs-button> -->
                                    
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Cancel' : 
                                data[indextr].isSubmitted == true  && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'Cancel' : 
                                data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? ' Cancel' : ''">
                                <!-- data[indextr].approversOTs[0].isRetracted == true ? 'Cancel' : ''"> -->
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledClaimsId)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="danger" type="border" icon-pack="feather" icon="icon-x" ></vs-button>
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledClaimsId)" v-else-if="data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                <!-- <vs-button class="mb-2" v-else-if="data[indextr].approversOTs[0].isApproved == true" color="danger" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>-->
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledClaimsId)" v-else-if="data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                <!-- <vs-button class="mb-2" v-else-if="data[indextr].approversOTs[0].isRetracted == true" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button> -->
                                     
                                </vx-tooltip>
                            </div>
                            <!--  -->
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

    </vx-card>


    
        <!-- ADD Claim -->
        <vs-prompt
            class="email-compose"
            title="Claims Request"
            accept-text= "Submit"
            @accept="onAddClaim"
            :is-valid="validForm"
            :active.sync="activePromptAddClaim">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getClaimTypes"> -->
            
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Name</span><span style="color:red">*</span>
                    <vs-input name="event-name" v-model="name" class="w-full"  placeholder="What to claim"/>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Reason</span><span style="color:red">*</span>
                    <vs-input name="claimAmount" v-validate="'required'" class="w-full"  v-model="reason" placeholder="Reason"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            
            
            <div class="vx-row mb-3">  
                <div class="vx-col w-full">
                    <table>
                        <thead>
                        <tr>
                            <th v-for="header in headers">
                            {{header}}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="claimsDetails.length === 0">
                            <td/>
                            <td/>
                            <td align="center" valign="center">No data</td>
                            <td/>
                            <td/>
                        </tr>
                        <tr v-else v-for="(item, index) in claimsDetails">

                            <td>{{item.particulars}}</td>
                            <td>{{ claimsCategoryName(item.claimsCategoryId).claimsCategoryName}}</td>
                            <td>{{ claimsSubCategoryName(item.claimsSubCategoryId).claimsSubCategoryName}}</td>
                            <td>{{item.amount}}</td>
                            <td><div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editItemRecord(index)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteItemRecord(index)" />
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                   
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full">
                <div class="flex flex-wrap justify-between mb-5">
                <vs-button @click="promptAddItem()">Add</vs-button>
                </div>
                </div>
            </div>
           <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reviewer</span><span style="color:red">*</span>
                    <vs-input name="reviewer" v-validate="'required'" class="w-full pointer-events-none" placeholder="Reviewer" v-model="claimsReviewerName.fullName" ></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Approver</span><span style="color:red">*</span>
                    <vs-input name="approver" v-validate="'required'" class="w-full pointer-events-none" placeholder="Approver" v-model="claimsApproverName.fullName" ></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2">
                    <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" text="Attachments"
                           />
            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>


        <!-- EDIT Claim -->
         <vs-prompt
            class="email-compose"
            title="Edit Claims Request"
            accept-text= "Submit"
            @accept="onEditClaim"
            :is-valid="validForm"
            :active.sync="activePromptEditClaim">
            <vx-card title="Edit the following information">
            
            
           <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Name</span><span style="color:red">*</span>
                    <vs-input name="event-name" v-model="name" class="w-full"  placeholder="What to claim"/>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Reason</span><span style="color:red">*</span>
                    <vs-input name="claimAmount" v-validate="'required'" class="w-full"  v-model="reason" placeholder="Reason"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            
            
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <div class="vx-col w-full">
                    <table>
                        <thead>
                        <tr>
                            <th v-for="header in headers">
                            {{header}}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="claimsDetails.length === 0">
                            <td/>
                            <td/>
                            <td align="center" valign="center">No data</td>
                            <td/>
                            <td/>
                        </tr>
                        <tr v-else v-for="(item, index) in claimsDetails">

                            <td>{{item.particulars}}</td>
                            <td>{{ claimsCategoryName(item.claimsCategoryId).claimsCategoryName}}</td>
                            <td>{{ claimsSubCategoryName(item.claimsSubCategoryId).claimsSubCategoryName}}</td>
                            <td>{{item.amount}}</td>
                            <td><div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editItemRecord(index)" />
                                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteItemRecord(index)" />
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                   
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                        <div class="flex flex-wrap justify-between mb-5">
                            <vs-button @click="promptEditItem()">Add</vs-button>
                        </div>
                    </div>
                </div>
                    <!-- <vs-table class="scroll-content" stripe max-items="4" pagination v-model="selected" :data="employeeClaimsDetails">
                        <template slot="thead">
                            
                            <vs-th>Particulars</vs-th>
                            <vs-th>Category</vs-th>
                            <vs-th>Sub Category</vs-th>
                            <vs-th>Amount</vs-th>
                            <vs-th>Actions</vs-th>
                        </template>
                         <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].particulars">
                                    {{data[indextr].particulars}}
                                </vs-td>
                                <vs-td :data="data[indextr].claimsCategoryId">
                                    {{ claimsCategoryName(data[indextr].claimsCategoryId) }}
                                </vs-td>
                                <vs-td :data="data[indextr].claimsSubCategoryId">
                                    {{ claimsSubCategoryName(data[indextr].claimsSubCategoryId) }}
                                </vs-td>
                                <vs-td :data="data[indextr].amount">
                                    {{data[indextr].amount }}
                                </vs-td>
                            </vs-tr>
                         </template>
                    </vs-table> -->
                </div>
            </div>
           <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reviewer</span><span style="color:red">*</span>
                    <vs-input name="reviewer" v-validate="'required'" class="w-full pointer-events-none" placeholder="Reviewer" v-model="claimsReviewerName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Approver</span><span style="color:red">*</span>
                    <vs-input name="approver" v-validate="'required'" class="w-full pointer-events-none" placeholder="Approver" v-model="claimsApproverName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2">
                <div  class="vx-col w-full mb-2">
                    <vs-button v-show="!isFileReplaced" @click="downloadFile(photoId)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachmentName}}</vs-button>
                </div>
                
                    <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" text="Attachments"/>
             
            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>





        <!-- DETAILS Claim -->
        <vs-prompt
            class="email-compose"
            title="Claims Details"
            :buttons-hidden = "true"
            accept-text="Ok"
            :active.sync="activePromptDetailsClaim">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getClaimTypes"> -->
            
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Name</span><span style="color:red">*</span>
                    <vs-input name="event-name" v-model="name" class="w-full pointer-events-none"  placeholder="What to claim" />
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Reason</span><span style="color:red">*</span>
                    <vs-input name="claimAmount" v-validate="'required'" class="w-full pointer-events-none"  v-model="reason" placeholder="Reason" ></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            
            
            <div class="vx-row mb-3">  
                <div class="vx-col w-full">
                    <table>
                        <thead>
                        <tr>
                            <th v-for="header in headers">
                            {{header}}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="claimsDetails.length === 0">
                            <td/>
                            <td/>
                            <td align="center" valign="center">No data</td>
                            <td/>
                            <td/>
                        </tr>
                        <tr v-else v-for="(item, index) in claimsDetails">

                            <td>{{item.particulars}}</td>
                            <td>{{ claimsCategoryName(item.claimsCategoryId).claimsCategoryName}}</td>
                            <td>{{ claimsSubCategoryName(item.claimsSubCategoryId).claimsSubCategoryName}}</td>
                            <td>{{item.amount}}</td>
                          
                        </tr>
                        </tbody>
                    </table>
                   
                </div>
            </div>
           
           <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reviewer</span><span style="color:red">*</span>
                    <vs-input name="reviewer" v-validate="'required'" class="w-full pointer-events-none" placeholder="Reviewer" v-model="claimsReviewerName.fullName"></vs-input>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Approver</span><span style="color:red">*</span>
                    <vs-input name="approver" v-validate="'required'" class="w-full pointer-events-none" placeholder="Approver" v-model="claimsApproverName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox class="pointer-events-none" color="rgb(21, 67, 252)" v-model="isDraft" >Save As Draft?</vs-checkbox>
                </div>
            </div>
             <div class="vx-row mb-2">
                <div  class="vx-col w-full mb-2">
                    <vs-button v-show="!isFileReplaced" @click="downloadFile(photoId)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachmentName}}</vs-button>
                </div>
            </div>
            <!-- Save & Reset Button -->
            <div class="flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="onDetailsClose()">Close</vs-button>
            <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
            </div>
           
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>

















        <!-- ADD ITEM -->
        <vs-prompt
            class="email-compose"
            title="Add Item"
            accept-text= "Add"
            cancel-text="Close"
            @accept="onAddItem"
            @cancel="onCloseItem"
            @close="onCloseItem"
            :is-valid="validItem"
            :active.sync="activePromptAddItem">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getClaimTypes"> -->
            
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Particulars</span><span style="color:red">*</span>
                    <vs-input name="particulars"  class="w-full"  v-model="particulars" placeholder="Particulars"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Category</span><span style="color:red">*</span>
                    <v-select name="category" v-model="claimsCategory" label="claimsCategoryName" :options="getclaimsCategory" class="w-full"  />
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Sub Category</span><span style="color:red">*</span>
                    <v-select name="subcategory"  class="w-full"  v-model="claimsSubCategory" label="claimsSubCategoryName" :options="getclaimsSubCategory" />
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Amount</span><span style="color:red">*</span>
                    <vs-input name="amount" v-validate="'required'" class="w-full"  v-model="amount" ></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>

           
            </vx-card>
        </vs-prompt>

        <!-- EDIT ITEM -->
        <vs-prompt
            class="email-compose"
            title="Edit Item"
            accept-text= "Update"
            cancel-text="Close"
            @accept="onUpdateItem"
            @cancel="onCloseUpdateItem"
            @close="onCloseUpdateItem"
            :is-valid="validItem"
            :active.sync="activePromptUpdateItem">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getClaimTypes"> -->
            
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Particulars</span><span style="color:red">*</span>
                    <vs-input name="particulars"  class="w-full"  v-model="particulars" placeholder="Particulars"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Category</span><span style="color:red">*</span>
                    <v-select name="category" v-model="claimsCategory" label="claimsCategoryName" :options="getclaimsCategory" class="w-full"  />
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Sub Category</span><span style="color:red">*</span>
                    <v-select name="subcategory"  class="w-full"  v-model="claimsSubCategory" label="claimsSubCategoryName" :options="getclaimsSubCategory" />
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Amount</span><span style="color:red">*</span>
                    <vs-input name="amount" v-validate="'required'" class="w-full"  v-model="amount" ></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>

           
            </vx-card>
        </vs-prompt>

        



        <!-- UNSUBMITDIALOG -->
        <vs-prompt
            title="Claim Un-Submit"
            @accept="onUnSubmit"
            accept-text= "Yes"
            :active.sync="activeUnSubmitDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            </div>
        </vs-prompt>


         <!-- RETRACK ADD COMMENT -->
        <vs-prompt
            title = "Retract Claim"
            @accept="onRetracked"
            accept-text= "Yes"
            :active.sync="activeRetrackDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="Remarks" v-model="remarks" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validreviewerComment" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>


         <!-- CANCEL Claim -->
        <vs-prompt
            title = "Claim Cancel"
            @accept="onCancelled"
            accept-text= "Yes"
            :active.sync="activeCancelDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="Remarks" v-model="remarks" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validreviewerComment" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>

    </div>


    
</template>

<script>
import Datepicker   from 'vuejs-datepicker'
import { en, he }   from 'vuejs-datepicker/src/locale'

import moduleClaims from '@/store/claims/moduleClaims.js'

import moment       from 'moment'
import vSelect      from 'vue-select'

import flatPickr    from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
         return {
            selected            :[],
            employeeFiledClaimsId: null,
            name                 : '',           
            reason              : '',
            isDraft             : false,
            isSubmitted         : true,
            submittedOn         : null,
            isCancelled         : false,
            cancelledOn         : null,
            photoId             : null,
            subscriptionId      : '58804fc5-45d5-46cb-a892-09fdda5824b4',
            comments            :'',
            remarks     : '',
            approverComment     : '',
            uploadPhoto         : [],
            dataImg             : null,
            claimsReviewerName    : [],
            claimsApproverName    : [],

            claimsDetailsId     : 0,
            claimsDetails       : [],
            claimsCategory      : {},
            claimsSubCategory   : {},
            particulars         : '',
            amount              : 0,
                                    
            headers             :[
                                    "Particulars",
                                    "Category",
                                    "Sub Category",
                                    "Amount",
                                    "Actions"
                                ],
            activePromptAddClaim    : false,
            activePromptEditClaim   : false,
            activeUnSubmitDialog    : false,
            activeRetrackDialog     : false,
            activeCancelDialog      : false,
            activePromptAddItem     : false,
            activePromptUpdateItem  : false,
            activePromptDetailsClaim: false,

            // getclaimsSubCategory: [],

            itemIndex               : null,
            isEditItem              : false,

            format              : "d MMMM yyyy",
            currentDate: new Date(),

            attachmentName: '',

            isFileReplaced: false,
         }   
    },
    created(){
        this.$store.registerModule('claims', moduleClaims)
        this.$store.dispatch('tenants/getAllSignatories', { tenantsId : this.$store.state.AppActiveUser.tenantsId }).catch((err) => { console.log(err)})
            .then((res) => {
                    this.claimsReviewerName = res.data.data.claimsReviewer
                    this.claimsApproverName = res.data.data.claimsApprover
                })
        const payload = {
                    sortBy      : 'CreatedOn',
                    sortOrder   : 'Desc',
                    pageNumber  : 1,
                    pageSize    : -1,
                    isApprover  : false
                }
                this.$store.dispatch('claims/getAllEmployeeClaims', payload)

        
        this.$store.dispatch('lookup/getAllClaimsCategory').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllClaimsSubCategory').catch((err) => { console.log(err)})
        
        // this.$store.dispatch('claims/getAllClaimType')
    },
    beforeDestroy () {
        this.$store.unregisterModule('claims')
    },
    computed: {
        employeeClaim () {
             return this.$store.state.claims.employeeFiledClaims 
        },
        employeeClaimsDetails : {
            get() { return this.$store.state.claims.getClaimsDetailsByClaimsId },
            set(value) { this.$store.dispatch('claims/getClaimsDetailsByClaimsId', value)
            }
        },
        
        getclaimsCategory() {
            return this.$store.state.lookup.claimsCategory
        },
        getclaimsSubCategory() {
            return this.$store.getters['lookup/claimsSubCategoryByCategory'](this.claimsCategory.claimsCategoryId)
            // get() { return this.$store.state.claims.claimsSubCategory },
            // set(value) { this.$store.getters['lookup/claimsSubCategoryByCategory'](value) }
        },
        getReviewer(){
            return this.$store.state.tenants.signatories.claimsReviewer //this.$store.state.tenants.signatories.claimsReviewer.firstName + ' ' + this.$store.state.tenants.signatories.claimsReviewer.lastName
        },
        getApprover(){
            return this.$store.state.tenants.signatories.claimsApprover//this.$store.state.tenants.signatories.claimsApprover.firstName + ' ' + this.$store.state.tenants.signatories.claimsApprover.lastName
        }, 
        validForm() {
            return  this.name != ''  && this.reason != ''
        },
        validItem() {
            return this.claimsCategory != null && this.claimsSubCategory != null && this.particulars != "" && this.amount > 0
        },
        validreviewerComment(){
            return  (this.remarks.length > 0)
        },
        claimsCategoryName(){
            return (id) => this.$store.getters['lookup/claimsCategoryName'](id)
        },
        claimsSubCategoryName(){
            return (id) => this.$store.getters['lookup/claimsSubCategoryName'](id)
        },
        
        
        

    },
    watch: {
        // claimsCategory(){
        //     this.getclaimsSubCategory = this.$store.getters['lookup/claimsSubCategoryByCategory'](this.claimsCategory.claimsCategoryId)
        // },
    
        isDraft() {
            if(!this.isDraft)
                this.isSubmitted = true
        },
    },
    methods: {
        promptAddNewClaim() {
            this.isEditItem = false
            this.addNewClaimDialog()
        },
        promptAddItem() {
            this.claimsCategory = this.claimsSubCategory = {}
            this.particulars = ""
            this.amount = 0
            this.addNewItem()
        },
        promptEditItem() {
            this.claimsCategory = this.claimsSubCategory = {}
            this.particulars = ""
            this.amount = 0
            this.updateItem()
        },
        addNewClaimDialog() {
            
            this.clearFields()
            this.activePromptAddClaim = true
        },
        addNewItem() {
            
            this.activePromptAddClaim = false
            this.activePromptAddItem = true
            
        },
        updateItem() {
            
            this.activePromptEditClaim = false
            this.activePromptAddItem = true
        },
        onDetailsClose() {
            this.activePromptDetailsClaim = false
        },
        editItemRecord(index) {
            this.itemIndex = index
            //console.log("EditItemRecord")
            //console.log(this.claimsDetails)
            this.claimsDetailsId =  this.isEditItem === true ? this.claimsDetails[index].id : null
            this.particulars = this.claimsDetails[index].particulars
            this.claimsCategory = this.claimsCategoryName(this.claimsDetails[index].claimsCategoryId)
            this.claimsSubCategory = this.claimsSubCategoryName(this.claimsDetails[index].claimsSubCategoryId)
            this.photoId = this.claimsDetails[index].photoId
            // this.claimsSubCategory = this.claimsDetails[index].claimsSubCategoryId
            this.amount = this.claimsDetails[index].amount
            this.activePromptEditClaim = false
            this.activePromptUpdateItem = true
        },
        confirmDeleteItemRecord(index) {
            if(this.isEditItem === true){
                this.$store.dispatch('claims/deleteClaimsDetails', this.claimsDetails[index].id)
                .then(response => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("", 'Deleted Successfully', "success")
                        else
                            this.$alert("", response.statusText, "error")
                
                })
                .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
                })
            } 
            this.claimsDetails.splice(index, 1)
            
        },
        onCloseItem() {
            this.activePromptAddClaim = true
        },
        onCloseUpdateItem() {
            this.activePromptEditClaim = true
        },
        clearFields() {
            this.name = this.reason = ''
            this.photoId = null
        },
        onAddClaim() {

            // Loading
            this.$vs.loading()

            if(this.isDraft) {
                this.isDraft = true
                this.isSubmitted = false
                this.submittedOn = null
            }else {
                this.submittedOn = new Date()
            }
            const data = {
                name: this.name,
                reason: this.reason,
                isDraft: this.isDraft,
                isSubmitted: this.isSubmitted,
                submittedOn: this.submittedOn,
                isCancelled: this.isCancelled,
                cancelledOn: this.cancelledOn,
                reviewerId: this.claimsReviewerName.userId, 
                approverId: this.claimsApproverName.userId, 
                photoId: this.photoId != null ? this.photoId : null,
                subscriptionId: this.subscriptionId,
                claimsDetails: this.claimsDetails
            }
            //console.log(data)
            this.$store.dispatch('claims/addClaims', data)
            .then((response) => {
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft)
                        this.$alert("You have successfully created your claim request and saved as draft", 'Draft Save Successfully', "success")
                    else 
                        this.$alert("You have successfully submitted your claim request", 'Claim Submitted', "success")
                    
                }
                else
                    this.$alert("", response.statusText, "error")
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
            })

            
        },
        onAddItem() {
            

            if(this.isEditItem === true) {
                const data = {
                    employeeFiledClaimsId : this.employeeFiledClaimsId,
                    claimsCategoryId    : this.claimsCategory.claimsCategoryId,
                    claimsSubCategoryId : this.claimsSubCategory.claimsSubCategoryId,
                    particulars         : this.particulars,
                    amount              : this.amount,
                    photoId             : this.photoId
                }
                
                this.$store.dispatch('claims/addClaimsDetails', data)
                .then(response => {
                        this.claimsDetails.unshift(response.data.data)
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("", 'Details Added', "success")
                        else
                            this.$alert("", response.statusText, "error")
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                })
                
                this.activePromptEditClaim = true
                this.activePromptAddItem = false
            }
            else {
                const data = {
                    claimsCategoryId    : this.claimsCategory.claimsCategoryId,
                    claimsSubCategoryId : this.claimsSubCategory.claimsSubCategoryId,
                    particulars         : this.particulars,
                    amount              : this.amount
                }

                this.claimsDetails.push(data)
                this.activePromptAddClaim = true
                this.activePromptAddItem = false
            }
            
        },
        onUpdateItem() {
            if(this.isEditItem === true) {
                const data = {
                    id                  : this.claimsDetailsId,
                    employeeFiledClaimsId : this.employeeFiledClaimsId,
                    claimsCategoryId    : this.claimsCategory.claimsCategoryId,
                    claimsSubCategoryId : this.claimsSubCategory.claimsSubCategoryId,
                    particulars         : this.particulars,
                    amount              : this.amount,
                    photoId             : this.photoId
                }
                this.$store.dispatch('claims/updateClaimsDetails', data)
                .then((response) => {
                        this.claimsDetails.splice(this.itemIndex, 1)
                        this.claimsDetails.unshift(response.data.data)
                        this.$vs.loading.close()

                        if(response.status == 200)
                            this.$alert("", 'Details Updated', "success")
                        else
                            this.$alert("", response.statusText, "error")
                       
                        this.activePromptEditClaim = true
                        this.activePromptUpdateItem = false
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                })
                

            }
            else {
                const data = {
                    claimsCategoryId    : this.claimsCategory.claimsCategoryId,
                    claimsSubCategoryId : this.claimsSubCategory.claimsSubCategoryId,
                    particulars         : this.particulars,
                    amount              : this.amount
                }
                this.claimsDetails.splice(this.itemIndex, 1)
                this.claimsDetails.push(data)
            }
            
            this.activePromptAddClaim = true
            this.activePromptUpdateItem = false
        },
        openEditClaim(Id){
                this.isEditItem = true
                const e = this.$store.getters['claims/employeeFiledClaims'](Id) 
                //console.log(e)
                this.employeeFiledClaimsId = e.employeeFiledClaimsId,
                this.name = e.name,
                this.reason= e.reason,
                this.isDraft= e.isDraft,
                this.isSubmitted= e.isSubmitted,
                this.submittedOn= e.submittedOn == null ? this.currentDate : e.submittedOn,
                this.isCancelled= e.isCancelled,
                this.cancelledOn= e.cancelledOn,
                this.photoId= e.photoId,
                this.subscriptionId= e.subscriptionId
                this.claimsDetails = e.claimsDetails

                this.getAttachmentName(this.photoId)

                this.activePromptEditClaim = true
                // this.$refs.upldphto.filesx[0] = "https://localhost:44346/api/photo/jpeg/20d4b681_bbfa_48bf_8bb4_cc79faa1529c.jpg"
            
        },
        onEditClaim() {
            
            const data = {
                employeeFiledClaimsId: this.employeeFiledClaimsId,     
                name: this.name,
                reason: this.reason,
                isDraft: this.isDraft,
                isSubmitted: this.isSubmitted,
                submittedOn: this.submittedOn,
                isCancelled: this.isCancelled,
                cancelledOn: this.cancelledOn,
                photoId: this.photoId != null ? this.photoId : null,
                subscriptionId: this.subscriptionId,
                reviewerId: this.claimsReviewerName.userId,//this.$store.state.tenants.signatories.claimsReviewer.userId,
                approverId: this.claimsApproverName.userId,// this.$store.state.tenants.signatories.claimsApprover.userId,
                claimsDetails: this.claimsDetails
            }
            this.$vs.loading()
            this.$store.dispatch('claims/updateClaims', data)
            .then(response => {
                this.employeeClaim = response.data.data
                    
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft)
                        this.$alert("You have successfully updated your claim request and saved as draft", 'Draft Save Successfully', "success")
                    else 
                        this.$alert("You have successfully submitted your claim request", 'Claim Submitted', "success")
                }
                else
                    this.$alert("", response.statusText, "error")
 
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
            })
        },
        openDetailsClaim(Id){
                this.isEditItem = true
                const e = this.$store.getters['claims/employeeFiledClaims'](Id) 
                this.employeeFiledClaimsId = e.employeeFiledClaimsId,
                this.name = e.name,
                this.reason= e.reason,
                this.isDraft= e.isDraft,
                this.isSubmitted= e.isSubmitted,
                this.submittedOn= e.submittedOn,
                this.isCancelled= e.isCancelled,
                this.cancelledOn= e.cancelledOn,
                this.photoId= e.photoId,
                this.subscriptionId= e.subscriptionId
                this.claimsDetails = e.claimsDetails

                this.getAttachmentName(this.photoId)

                this.activePromptDetailsClaim = true
                // this.$refs.upldphto.filesx[0] = "https://localhost:44346/api/photo/jpeg/20d4b681_bbfa_48bf_8bb4_cc79faa1529c.jpg"
            
        },
        onUnSubmit() {
                //console.log(this.employeeFiledClaimsId)
                this.$vs.loading()
                const data = {
                    employeeFiledClaimsId: this.employeeFiledClaimsId,
                    action: "UNSUBMIT",
                    isDraft : true,
                    isSubmitted: false,
                    reviewerId: this.claimsReviewerName.userId
                }
                this.$store.dispatch('claims/unSubmit', data)
                .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("You have successfully un-submit your claim request", 'Un-Submit Successfully', "success")
                    else
                            this.$alert("", response.statusText, "error")
               })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                })
        },
        onRetracked() {
                ////console.log(employeeFiledClaimsId)
                this.$vs.loading()
                const data = {
                    employeeFiledClaimsId: this.employeeFiledClaimsId,
                    action: "RETRACKED",
                    isDraft : false,
                    isRetracted : true,
                    retractedOn : this.currentDate,
                    isApproved: false,
                    remarks : this.remarks,
                    approverId: this.approvers.userId
                }
                this.$store.dispatch('claims/onRetracked', data)
                .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully retracted your claim request", 'Retracted Successfully', "success")
                        else 
                            this.$vs.loading.close()
                    })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onCancelled() {
                this.$vs.loading()
                const data = {
                    employeeFiledClaimsId: this.employeeFiledClaimsId,
                    action: "CANCELLED",
                    isDraft : false,
                    isSubmitted: false,
                    isCancelled : true,
                    cancelledOn : this.currentDate,
                    isRevised : false,
                    remarks : this.remarks,
                    approverId: this.approvers.userId
                }
                this.$store.dispatch('claims/onCancelled', data)
                .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully cancelled your claim request", 'Cancelled Successfully', "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        successUpload(){
            
            this.$vs.notify({color:'success',title:'Upload Success',text:''})
        },
        deleteUpload(){
            this.$store.dispatch('deleteFile', this.photoId)
                .then(() => {
                    this.photoId = null
                })
        },
        
        updateCurrImg (e) {
            

            if(this.$refs.upldphto.filesx[0].type =='application/x-msdownload')
            {
                this.$vs.notify({
                        title: 'Info',
                        text: "File not allowed",
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'warning'
                        })
                return
            }
                
            this.$vs.loading()
             if(this.$refs.upldphto.filesx.length > 0)
            {

                let files = this.$refs.upldphto.filesx

                files.forEach(file => {

                    if(!file.remove)
                    {
                        let formData = new FormData()
                    
                        formData.append('UserId',  this.$store.state.AppActiveUser.uid)
                        formData.append('Title', this.claimsCategory.claimsCategoryName)
                        formData.append('Description', this.reason)
                        formData.append('Path', "")
                        formData.append('BlobContainer', "")
                        formData.append('OrigFilename', file.name)
                        formData.append('ContentType', file.type)
                        formData.append('Tags', "")
                        formData.append('file', file)
                        
                        this.$store.dispatch('uploadFile', formData)
                            .then((response) => {
                                this.$vs.loading.close()
                                if(response.status == 200){
                                    this.photoId = response.data.item2
                                }
                                    
                            })
                            .catch((error) => {
                                this.$vs.loading.close()
                                console.log(error.message)
                            })
                    }
                });
            }



             this.$vs.loading.close()
        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
        getAttachmentName(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    this.attachmentName = fileName.replace('"', '').replace('"', '')
                })
        },
        promptUnSubmitDialog(Id) {
            this.remarks = ''
            this.employeeFiledClaimsId = Id
            this.activeUnSubmitDialog = true
        },
        promptRetrackDialog(Id) {
            this.remarks = ''
            this.employeeFiledClaimsId = Id
            this.activeRetrackDialog = true
        },
        promptCancelDialog(Id) {
            this.remarks = ''
            this.employeeFiledClaimsId = Id
            this.activeCancelDialog = true
        },
        refreshcard () {
            this.$vs.loading({
                container: this.$refs.content,
                scale: 0.5
            })
            this.tempHidden = true
            this.$emit('refresh', this)
        },
        
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";

table {
//   font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
//   border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
//   background-color: #dddddd;
}
</style>